import heic2any from 'heic2any'

/**
 * Convert a HEIC/HEIF blob to a JPEG blob for browser display only.
 * Applicant module uploads the original HEIC file; conversion is only for <img> preview.
 * The caller must revoke the returned object URL when done (URL.revokeObjectURL).
 */
export async function convertHeicBlobToJpegUrl(blob: Blob): Promise<string> {
  const result = await heic2any({
    blob,
    toType: 'image/jpeg',
    quality: 0.92,
  })
  const outBlob = Array.isArray(result) ? result[0] : result
  return URL.createObjectURL(outBlob)
}
